import { getDebounce } from 'utils';
import store from '../../../../state';

const debounce = getDebounce();

const updateState = (vehicles, updatedVehicle, internalStateSetter, outlet) => {
  internalStateSetter({ vehicle: updatedVehicle });

  const updatedVehicles = vehicles.map((item) => {
    if (item.id === updatedVehicle.id) return updatedVehicle;
    return item;
  });

  outlet({ vehicles: updatedVehicles });
};

export const validation = (field, vehicle) => {
  const { language } = store.store.getState();

  let errors = {};
  const { color, licensePlate, modal, state } = vehicle;
  if ((field === 'modal') && modal.length < 3) {
    errors = { ...errors, modalError: language.vehicle_errors.model };
  }

  if ((field === 'color') && color.length < 3) {
    errors = { ...errors, colorError: language.vehicle_errors.color };
  }

  if ((field === 'licensePlate') && licensePlate.length < 3) {
    errors = { ...errors, licensePlateError: language.vehicle_errors.license };
  }
  if ((field === 'state') && state.length < 2) {
    errors = { ...errors, stateError: language.vehicle_errors.state };
  }

  if (Object.keys(errors).length) {
    const withErrors = { ...vehicle, ...errors, hasError: true };
    return withErrors;
  }
  return { ...vehicle, hasError: false };
};

export const validator = (field, vehicle, vehicles, internalStateSetter, outlet) => {
  const result = validation(field, vehicle);
  updateState(vehicles, result, internalStateSetter, outlet);
};

const validate = (fieldName, updatedVehicles, vehicles, setter, outlet) => {
  debounce(() => validator(fieldName, updatedVehicles, vehicles, setter, outlet), 3000);
};

export {
  validate,
  updateState
};
